import request from '@/utils/request';

// 获取AI语音助手技能提示列表
export function deskAdvertisingList(options) {
  return request({
    url: `/op/deskAdvertising/list`,
    method: 'get',
    params: options
  });
}
